import { flowmeterElementConfig } from "./flowmeterSensorElement.js";
import { humidityElementConfig } from "./humiditySensorElement.js";
import { inclinationAngleElementConfig, inclinationDirectionElementConfig } from "./inclinationSensorElement.js";
import { pressureTransducerElementConfig } from "./pressureTransducerSensorElement.js";
import { pulseTotalizerElementConfig } from "./pulseTotalizerSensorElement.js";
import {
    digitalCodeElementConfig,
    digitalCountElementConfig,
    digitalPercentageElementConfig,
    digitalPrecipitationElementConfig,
    digitalVoltageElementConfig,
} from "./simpleDigitalSensorElements.js";
import { soilTemperatureElementConfig } from "./soilTemperatureSensorElement.js";
import { solarRadiationElementConfig } from "./solarRadiationSensorElement.js";
import {
    gen4SolenoidVerificationElementConfig,
    saplingVerificationElementConfig,
} from "./solenoidVerificationSensorElement.js";
import { stemRadiusChangeElementConfig } from "./stemRadiusChangeSensorElement.js";
import { temperatureElementConfig } from "./temperatureSensorElement.js";
import { SensorElementConfig } from "./types.js";
import { valveStateElementConfig } from "./valveStateSensorElement.js";
import { volumetricWaterContentElementConfig } from "./volumetricWaterContentSensorElement.js";
import {
    zoneIrrigationScheduledElementConfig,
    zoneNdviElementConfig,
    zoneNdviVarianceElementConfig,
} from "./zoneVirtualSensorElements.js";

export const sensorElementConfigs: Record<string, SensorElementConfig<any>> = {
    // Physical external sensors
    flowmeter: flowmeterElementConfig,
    pressureTransducer: pressureTransducerElementConfig,
    pulseTotalizer: pulseTotalizerElementConfig,
    volumetricWaterContent: volumetricWaterContentElementConfig,

    // Physical internal sensors
    temperature: temperatureElementConfig,
    soilTemperature: soilTemperatureElementConfig,
    humidity: humidityElementConfig,

    // Generation-specific virtual diagnostic sensors
    valveState: valveStateElementConfig,
    gen4SolenoidVerification: gen4SolenoidVerificationElementConfig,
    saplingVerification: saplingVerificationElementConfig,

    // Zone virtual sensors
    zoneNdvi: zoneNdviElementConfig,
    zoneNdviVariance: zoneNdviVarianceElementConfig,
    zoneIrrigationScheduled: zoneIrrigationScheduledElementConfig,

    // Simple digital sensor elements — generic reusable building blocks
    digitalCount: digitalCountElementConfig,
    digitalVoltage: digitalVoltageElementConfig,
    digitalPercentage: digitalPercentageElementConfig,
    digitalCode: digitalCodeElementConfig,
    digitalPrecipitation: digitalPrecipitationElementConfig,

    // Physical environmental sensors
    stemRadiusChange: stemRadiusChangeElementConfig,
    inclinationAngle: inclinationAngleElementConfig,
    inclinationDirection: inclinationDirectionElementConfig,
    solarRadiation: solarRadiationElementConfig,
};
